import { render } from "./SysProgram.vue?vue&type=template&id=13d048d6&scoped=true"
import script from "./SysProgram.vue?vue&type=script&lang=js"
export * from "./SysProgram.vue?vue&type=script&lang=js"

import "./SysProgram.vue?vue&type=style&index=0&id=13d048d6&lang=less&scoped=true"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d048d6"]])

export default __exports__